import { RankingDto } from "../../../../../../../../../api/runner-ranking";
import {
  FestivalRankItemWrapper,
  FestivalRankUserInfo,
  FestivalRankUserWrapper,
} from "./style";

export interface RabbitREstivalRankItemProps {
  item: RankingDto;
}

const RabbitFestivalRankItem = ({ item }: RabbitREstivalRankItemProps) => {
  return (
    <FestivalRankItemWrapper>
      <FestivalRankUserWrapper>
        <div className="rank">{item.rank}위</div>
        <FestivalRankUserInfo>
          <div className="nickname">{item.nickname}</div>
          <div className="pub">{item.pubName}</div>
        </FestivalRankUserInfo>
      </FestivalRankUserWrapper>
      <div className="point">{(item.points / 100).toFixed(2)} PT</div>
    </FestivalRankItemWrapper>
  );
};

export default RabbitFestivalRankItem;
